/**
 * menuLiveData.ts — live progression data feed for the start menu (BETA 22.50).
 *
 * The old canvas menu (MenuRenderer, deleted with the classroom rebuild) owned
 * these module-scoped setters; Home.tsx pushes lifetime stats / completed
 * quests / bot-mode into them on every goopState change. Kept as a standalone
 * store so the new StartMenu (and future unlock displays) can read the same
 * data without dragging 3600 lines of dead canvas code around.
 */
import type { LifetimeStats } from './goopSystem';

let _liveStats: LifetimeStats | null = null;
let _completedQuestIds: Set<string> = new Set();
let _botModeActive = false;

export function setMenuLiveData(stats: LifetimeStats, completedQuests: Set<string>): void {
  _liveStats = stats;
  _completedQuestIds = completedQuests;
}

export function setMenuBotMode(active: boolean): void { _botModeActive = active; }

export function getMenuLiveStats(): LifetimeStats | null { return _liveStats; }
export function getMenuCompletedQuests(): Set<string> { return _completedQuestIds; }
export function isMenuBotMode(): boolean { return _botModeActive; }
